import ProfileView from "./ProfileView/ProfileView";
import ProjectView from "./ProjectView/ProjectView";
import ConnectView from "./ConnectView/ConnectView";
import { mainContents } from "../utility/constants/resource/resource";

const viewMap: { [name: string]: JSX.Element } = {
  bio: <ProfileView />,
  project: <ProjectView />,
  connect: <ConnectView />,
};

const ContentView = ({ name }: { name: string }): JSX.Element => {
  const content = mainContents.find((x) => x.name === name);
  return content?.isVisible ? viewMap[name] : <></>;
};
export default ContentView;
